import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import auth from './modules/auth'
import snackbar from './modules/snackbar'
import entities from './modules/entities'
import users from './modules/users'
import roles from './modules/roles'
import clients from './modules/clients'
import devices from './modules/devices'
import licences from './modules/licences'
import applications from './modules/applications'
import counters from './modules/counters'
import customizations from './modules/customizations'

export default new Vuex.Store({
  modules: { auth, snackbar, entities, users, roles, clients, devices, licences, applications, counters, customizations },
  state: {
    loading: false
  },
  mutations: {
    showLoading (state) {
      state.loading = true
    },
    hideLoading (state) {
      state.loading = false
    }
  },
  actions: {
    fetchAll ({ dispatch, rootState }) {
      let isAdminReseller = rootState.auth.user.is_admin_reseller
      if (isAdminReseller) {
        return Promise.all([dispatch('entities/fetchAll'), dispatch('clients/fetchAll'), dispatch('devices/fetchAll'), dispatch('users/fetchAll'), dispatch('roles/fetchAll'), dispatch('licences/fetchAll'), dispatch('applications/fetchAll')]);
      }
      return Promise.all([dispatch('clients/fetchAll'), dispatch('devices/fetchAll'), dispatch('licences/fetchAll'), dispatch('applications/fetchAll')]);
    },
  }
})
